<script>
import Layout from '@/components-v4/layout/main.vue'
import Loading from '@/components-v4/loading/loading.vue'

export default {
  page: {
    title: 'tamara - loading',
    meta: [{ name: 'description', content: 'Welcome to tamara' }],
  },
  components: {
    Layout,
    Loading,
  },
}
</script>

<template>
  <Layout hide-header hide-footer show-bottom-background>
    <Loading
      visible
      overlay="0"
      light
      :dark="false"
      z-index="2024"
      opacity="0.95"
      color="white"
    />
  </Layout>
</template>
